import { __read } from "tslib";
import { useState } from 'react';
import { useToggleable } from '../../../hooks';
export var useConsole = function () {
    var _a = useToggleable(false), isOpen = _a.isOpen, open = _a.open, close = _a.close;
    var _b = __read(useState(''), 2), command = _b[0], setCommand = _b[1];
    return { isOpen: isOpen, open: open, close: close, command: command, setCommand: setCommand };
};
